import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TableContainer,
  Select,
  Paper,
  TextField,
  IconButton,
  Box,
  Button,
  Autocomplete,
  CircularProgress,
  Checkbox,
  MenuItem,
  InputLabel,
  FormControl,FormHelperText
} from "@mui/material";
import { GlobalStyles, margin } from "@mui/system";
import { useAuth } from "../../../../AuthProvider";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import DeleteIcon from "@mui/icons-material/Delete";
import Chip from "@mui/material/Chip";

import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

function ParentMeetings() {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const { userId, oId,role,pId ,board} = useAuth();

  const [teachers, setTeachers] = useState([]);
  const [recipients, setRecipients] = useState([]);
  const [selectedRecipients, setSelectedRecipients] = useState([]);
  const [teacherLoading, setTeacherLoading] = useState(false);
  const [teacherMeeting, setTeacherMeeting] = useState(false);
  const [meetings, setMeetings] = useState([]); // State to store fetched data
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [formattedTime, setFormattedTime] = useState("");
  const [loadingData, setLoadingData] = useState(true); // ✅ Define loading state
const [sscClassOptions, setSscClassOptions] = useState([]);

  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState('');
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const UserId = userId || selectedUsers;

  const handleTimeChange = (newValue) => {
    if (!newValue) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        time: "Meeting time is required",
      }));
      return;
    }

    const formattedTime = dayjs(newValue).format("hh:mm A"); // Convert to 12-hour format
    setFormData((prev) => ({ ...prev, time: formattedTime }));

    // Clear error when time is selected
    setErrors((prevErrors) => ({
      ...prevErrors,
      time: "",
    }));
  };

  const [searchQuery, setSearchQuery] = useState("");
  const [formData, setFormData] = useState({
    title: "",
    // recipients: "All Parents Meeting",
    recipients: "",
    time: "",
    purposeDate: "",
    meetingPurpose: "",
    // time: "",
  });

  const filteredMeetings = meetings.filter((data) => {
    // Convert date to MM/DD/YYYY format
    const formattedDate = new Date(data.purposeDate).toLocaleDateString();

    return (
      data.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      data.purposeDate.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });







  const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`);
    const data = await response.json();

    if (response.ok && Array.isArray(data)) {
      // Group by class and merge section strings into unique values
      const classSectionMap = {};

      data.forEach(item => {
        const className = item.classRegistration;
        const sectionList = item.sections.split(",").map(s => s.trim());

        if (!classSectionMap[className]) {
          classSectionMap[className] = new Set();
        }

        sectionList.forEach(section => classSectionMap[className].add(section));
      });

      const classes = Object.keys(classSectionMap);
      setSscClassOptions(classes); // Class dropdown options

      // No default selection
      // setSscSelectedClass("");
      // setSscSelectedSection("");
      // setSscSectionOptions([]);
    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};


useEffect(() => {
  if(board === "SSC"){
    fetchClassRegistrationData();
  }
}, []); // ✅ Only runs on mount 


   const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/SCHEDULE_MEETING/${oId}/${pId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setUsers(data);
            if (data.length > 0) {
              setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
 useEffect(() => {
  if (isPrincipal) {
    fetchUsers();
  }
}, []); // ✅ Only runs on mount 

  // for getAll api

  const fetchTeachers = async () => {
    if (!UserId) {
      setLoadingData(false); // Ensure loading state is removed if no bus is selected
      return; 
    }
    setLoadingData(true); // Start loading
    try {
      const response = await fetch(
        `${baseUrl}/api/parentMeeting/getAllParentMeetingsBy/${UserId}/${oId}`
      );
      const data = await response.json();

      // ✅ Sort notices by purposeDate (future dates first)
      data.sort((a, b) => new Date(b.purposeDate) - new Date(a.purposeDate));

      // Use reversedData as needed (e.g., setting state)

      if (Array.isArray(data)) {
        setMeetings(data); // Assuming `setMeetings` is your state setter
      } else {
        console.error("API response is not an array:", data);
        setMeetings([]); // Set to an empty array if response is invalid
      }
    } catch (error) {
      setMeetings([]);
      console.error(error);
      // toast.error(error.message);
    } finally {
      setLoadingData(false); // Stop loading
    }
  };
  useEffect(() => {
    fetchTeachers();
  }, [ oId,UserId]);

  

 
   




  const validateForm = () => {
    const newErrors = {};

    // if (!formData.title.trim()) newErrors.title = "Meeting title is required";
  if (!formData.title || !formData.title.trim()) {
  newErrors.title = "Meeting title is required";
}


     if (!formData.recipients) {
    newErrors.recipients = "Please select at least one class";
  }


    // if (!formData.time) newErrors.time = "Meeting time is required";

    if (!formData.purposeDate) {
      newErrors.purposeDate = "Meeting date is required";
    } else {
      const today = new Date().toISOString().split("T")[0]; // Get today's date
      if (formData.purposeDate < today)
        newErrors.purposeDate = "Meeting date cannot be in the past";
    }

    if (!formData.meetingPurpose.trim()) {
      newErrors.meetingPurpose = "Meeting purpose is required";
    } else if (formData.meetingPurpose.length < 10) {
      newErrors.meetingPurpose =
        "Meeting purpose must be at least 10 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };





  const handleChange = (e) => {
    const { name, value } = e.target;

    // Update form state
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Real-time validation
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: validateField(name, value),
    }));
  };

  // Function to validate each field individually
  // const validateField = (name, value) => {
  //   switch (name) {
  //     case "title":
  //       // return value.trim() ? "" : "Meeting title is required";
  //       if (!value.trim()) {
  //         return "Meeting title is required";
  //       } else if (!/^[A-Za-z\s]+$/.test(value)) {
  //         return "Only letters are allowed";
  //       }

  //     case "purposeDate":
  //       if (!value) return "Meeting date is required";
  //       const today = new Date().toISOString().split("T")[0]; // Get today's date
  //       return value < today ? "Meeting date cannot be in the past" : "";

  //     case "meetingPurpose":
  //       if (!value.trim()) return "Meeting purpose is required";
  //       return value.length < 10
  //         ? "Meeting purpose must be at least 10 characters"
  //         : "";

  //     default:
  //       return "";
  //   }
  // };

  const validateField = (name, value) => {
  switch (name) {
    case "title":
      if (!value || !value.trim()) {
  return "Meeting title is required";
}
return "";


      return "";

    case "purposeDate":
      if (!value) return "Meeting date is required";
      const today = new Date().toISOString().split("T")[0];
      return value < today ? "Meeting date cannot be in the past" : "";

    case "meetingPurpose":
      if (!value.trim()) return "Meeting purpose is required";
      return value.length < 10
        ? "Meeting purpose must be at least 10 characters"
        : "";

    case "recipients":
      return value ? "" : "Please select a class";

    default:
      return "";
  }
};



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading

    if (!validateForm()) {
      setLoading(false); // Stop loading if validation fails
      return;
    }

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("title", formData.title);
      // formDataToSend.append("recipients",formData.recipients);
      formDataToSend.append("recipients",formData.recipients);
      // formDataToSend.append("time", formData.time); // Convert time here
      formDataToSend.append("purposeDate", formData.purposeDate);
      formDataToSend.append("meetingPurpose", formData.meetingPurpose);

      const response = await fetch(
        `${baseUrl}/api/parentMeeting/saveParentMeeting/${UserId}`,
        {
          method: "POST",
          body: formDataToSend,
        }
      );

      if (!response.ok) throw new Error("Failed to save meeting");

      // setMeetings((prevMeetings) => [newMeeting, ...prevMeetings]); // Add new meeting on top
      toast.success("Parents Meeting Scheduled Successfully", { autoClose: 1000 });
      fetchTeachers();

      setFormData({
        title: "",
        time: "",
        purposeDate: "",
        meetingPurpose: "",
      });
      setFormattedTime("");
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteMeeting = (data) => {
    Swal.fire({
      title: "Are you sure?",

      text: `You Want To Delete "${data.title}" From The Meeting List.`,

      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      // ✅ Using async here
      if (result.isConfirmed) {
        try {
          const response = await fetch(
            `${baseUrl}/api/parentMeeting/deleteMeeting/${data.id}/${oId}`,
            { method: "DELETE" }
          );

          if (!response.ok) throw new Error("Failed to delete the meeting");
          fetchTeachers();

          // Swal.fire("Deleted!");
          toast.success("Your meeting has been deleted.", "success");
        } catch (error) {
          // Swal.fire("Error!", error.message, "error");
          toast.error(error.message);
        }
      }
    });
  };

  return (
    <Card
      style={{
        margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#fff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
      }}
    >
      <CardContent>
        <Typography
          variant="h4"
          style={{ fontWeight: "bold", color: "#333", textAlign: "center" }}
        >
          Schedule Parents Notification
        </Typography>

        <Grid
          container
          spacing={2}
          sx={{ marginTop: "10px", alignItems: "stretch" }}
        >
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                padding: "15px",
                borderRadius: "8px",
                boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.25)",
                backgroundColor: "#ffffff",
                // height: "100%", // Ensure both sections have the same height
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "#333", marginBottom: "15px" }}
              >
                Schedule New Notification
              </Typography>

              <form onSubmit={handleSubmit} style={{ flexGrow: 1 }}>
                <TextField
                  name="title"
                  label="Meeting Title"
                  value={formData.title}
                  onChange={handleChange}
                  fullWidth
                  sx={{ mb: 1 }}
                  error={!!errors.title}
                  helperText={errors.title}
                />
                 {/* <TextField
                  name="Recepients"
                  label="Meeting Title"
                  value={formData.recipients}
                  onChange={handleChange}
                  fullWidth
                  sx={{ mb: 1 }}
                  error={!!errors.recipients}
                  helperText={errors.recipients}
                  InputLabelProps={{ shrink: true }}
                  disabled
                  InputProps={{
                    style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'},
                  }}
                /> */}


                  {board === "SSC" && (
          <>
                 <FormControl fullWidth sx={{ mb: 1 }} error={!!errors.recipients}>
  <InputLabel>Select Class</InputLabel>
  <Select
    name="recipients" // ✅ Required for handleChange to work
    value={formData.recipients}
    label="Select Class"
    onChange={handleChange}
  >
    <MenuItem value="All">All Parents Meeting</MenuItem>
    {sscClassOptions.map((cls) => (
      <MenuItem key={cls} value={cls}>{cls}</MenuItem>
    ))}
  </Select>
  {errors.recipients && (
    <FormHelperText>{errors.recipients}</FormHelperText>
  )}
</FormControl>

                  
          </>
        )}
        
{/*         
        {board === "INTERMEDIATE" && (
          <>
           <FormControl fullWidth>
                    <InputLabel>Select Class</InputLabel>
                    <Select
                      value={romanNumberClass}
                      label="Select Class"
                      onChange={(e) => setRomanNumberClass(e.target.value)}
                    >
                        <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
                        <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
                    </Select>
                  </FormControl>
        
        
                      <FormControl fullWidth size="medium">
          <InputLabel id="course-type-label">Select Course*</InputLabel>
          <Select
            labelId="course-type-label"
            value={dialogcourse}
            onChange={(e) => setDialogCourse(e.target.value)}
            label="Select Course*"
          >
            {courseOptions.length > 0 ? (
              courseOptions.map((course, index) => (
                <MenuItem key={index} value={course}>
                  {course}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>No courses available</MenuItem>
            )}
          </Select>
        </FormControl>
           </>
        )} */}



                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    label="Time"
                    value={
                      formData.time ? dayjs(formData.time, "hh:mm A") : null
                    }
                    onChange={handleTimeChange}
                    sx={{ width: "100%", marginBottom: "10px" }}
                    ampm // Ensures 12-hour format with AM/PM
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        sx: { mb: 1 },
                        error: !!errors.time,
                        helperText: errors.time || " ", // Ensures consistent spacing
                      },
                    }}
                  />
                </LocalizationProvider> */}

                <TextField
                  name="purposeDate"
                  label="Date"
                  type="date"
                  value={formData.purposeDate}
                  onChange={handleChange}
                  // onChange={handleTimeChange}
                  fullWidth
                  sx={{ mb: 1 }}
                  error={!!errors.purposeDate}
                  helperText={errors.purposeDate}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  name="meetingPurpose"
                  label="Meeting Purpose"
                  multiline
                  rows={3}
                  value={formData.meetingPurpose}
                  onChange={handleChange}
                  // onChange={handleTimeChange}
                  fullWidth
                  sx={{ mb: 1 }}
                  error={!!errors.meetingPurpose}
                  helperText={errors.meetingPurpose}
                />


                {/* Dropdown for Select User - Right Next to Date Selection */}
                                      {/* {isPrincipal && (
                                        <Grid item xs={12} sm={14} >
                                          <FormControl fullWidth variant="outlined" size="meddium">
                                            <InputLabel>Select Schedule Admin</InputLabel>
                                            <Select
                                              value={selectedUsers}
                                              onChange={(e) => setSelectedUsers(e.target.value)}
                                              label="Select Schedule Admin"
                                              // sx={{ height: "36px", display: "flex", alignItems: "center" }} // Matching height
                                            >
                                              {users.map((user) => (
                                                <MenuItem key={user.userId} value={user.userId}>
                                                  {user.userId} - {user.firstName} {user.lastName}
                                                </MenuItem>
                                              ))}
                                            </Select>
                                          </FormControl>
                                        </Grid>
                                      )} */}



                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{
                      backgroundColor: "#6E69B0",
                      color: "white",
                      marginTop:"10px",
                      minWidth: "130px",
                      "&:hover": {
                        backgroundColor: "#58548E",
                      },
                    }}
                    disabled={loading} // Disable button while loading
                  >
                    {loading ? (
                      <CircularProgress size={24} sx={{ color: "white" }} />
                    ) : (
                      "Submit"
                    )}
                  </Button>
                </Box>
              </form>
            </Box>
          </Grid>

          <Grid item xs={12} md={8}>
            <Box
              sx={{
                padding: "15px",
                borderRadius: "8px",
                boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.25)",
                backgroundColor: "#f9f9f9",
              }}
            >
              <Typography
                variant="h5"
                sx={{ fontWeight: "bold", color: "#333", marginBottom: "15px" }}
              >
                Scheduled Notifications
              </Typography>

              <Grid container spacing={2} sx={{ marginBottom: "15px" }}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Search by Date or Title"
                    size="small"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="YYYY-MM-DD or Title"
                  />
                </Grid>
              </Grid>

              <Box
                sx={{ borderBottom: "1px solid #ddd", marginBottom: "15px" }}
              />

              <GlobalStyles
                styles={{
                  ".custom-sidebar-scrollbar": {
                    scrollbarWidth: "thin", // For Firefox
                    scrollbarColor: "grey #e0e0e0",
                  },
                  ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                    width: "6px", // For WebKit-based browsers
                  },
                  ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                    background: "#f1f1f1", // Track color
                  },
                  ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                    backgroundColor: "grey", // Thumb color
                    borderRadius: "10px",
                  },
                  ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "#555",
                  },
                }}
              />

              <Box
                sx={{
                  maxHeight: "400px",
                  overflowY: "auto",
                  paddingRight: "10px",
                }}
                className="custom-sidebar-scrollbar"
              >
                <Grid container spacing={2}>
                  {loadingData ? ( // Show loader when loading
                                          <Box display="flex" flexDirection="column" alignItems="center" width="100%" sx={{ mt: 2 }}>
                                            <CircularProgress />
                                            <Typography variant="body2" sx={{ mt: 1 }}>
                                              Loading Meetings List...
                                            </Typography>
                                          </Box>
                                        
            ) : filteredMeetings.length === 0 ? (
                    <Typography
                      variant="h6"
                      sx={{
                        textAlign: "center",
                        color: "#666",
                        width: "100%",
                        padding: "20px",
                        fontStyle: "italic",
                      }}
                    >
                      No Meetings Found, Schedule A New Meeting.
                    </Typography>
                  ) : (
                    filteredMeetings.map((data, index) => (
                      <Grid item xs={12} key={index}>
                       <Box
  sx={{
    padding: "10px",
    borderRadius: "10px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#D1E9F6",
    position: "relative",
    overflow: "hidden",
    marginTop: "10px",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: "#b3d8ec", // Slightly darker shade on hover
    },
    "&:hover .delete-button": { opacity: 1 }, // Show delete button on hover
  }}
>
  {/* "New!" Ribbon Badge */}
  {(() => {
    const currentTime = new Date();
   const hasTime = Boolean(data?.time);

let isNew = false;

if (hasTime) {
  const currentTime = new Date();
  const [timeString, period] = data.time.split(" ");
  const [hours, minutes] = timeString.split(":").map(Number);

  let adjustedHours =
    period === "PM" && hours !== 12 ? hours + 12 : hours;
  if (period === "AM" && hours === 12) adjustedHours = 0;

  const noticeDateTime = new Date(data.purposeDate);
  noticeDateTime.setHours(adjustedHours, minutes, 0, 0);

  isNew = currentTime < noticeDateTime;
}


    return isNew ? (
      <Box
        sx={{
          position: "absolute",
          top: "0",
          right: "0",
          backgroundColor: "blue",
          color: "#fff",
          fontWeight: "bold",
          fontSize: "0.75rem",
          padding: "5px 10px",
          textTransform: "uppercase",
          borderTopRightRadius: "8px",
          borderBottomLeftRadius: "8px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        }}
      >
        New!
      </Box>
    ) : null;
  })()}

  {/* Delete Icon - Now positioned correctly and shown only on hover */}
  <IconButton
  className="delete-button"
  sx={{
    position: "absolute",
    right: "10px", // Keep it aligned to the right
    top: "50%", // Center vertically
    transform: "translateY(-50%)", // Adjust for exact centering
    backgroundColor: "#ff0000",
    color: "#fff",
    opacity: 0, // Initially hidden
    transition: "opacity 0.2s ease-in-out",
    "&:hover": { backgroundColor: "#d32f2f" },
  }}
  onClick={() => handleDeleteMeeting(data)}
>
  <DeleteIcon />
</IconButton>


  <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
    <Box
      sx={{
        backgroundColor: "#00796B",
        color: "#FFFFFF",
        borderRadius: "8px",
        padding: "10px",
        fontSize: "0.9rem",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: "40px",
        width: "100px",
        fontWeight: "bold",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      }}
    >
      {data.purposeDate}
    </Box>

    {/* <Box
      sx={{
        backgroundColor: "#4682B4",
        color: "#fff",
        borderRadius: "8px",
        padding: "10px",
        fontSize: "0.9rem",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: "40px",
        width: "100px",
        fontWeight: "bold",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      }}
    >
      {data.time}
    </Box> */}
  </div>

  {/* <Typography
    variant="h5"
    sx={{
      fontWeight: "bold",
      color: "#333",
      marginTop: "10px",
    }}
  >
    {data.title}
  </Typography> */}
  <Box display="flex" alignItems="center" mt={1}>
  <Typography
    variant="h6"
    sx={{
      fontWeight: 600,
      color: "#555",
      marginRight: "8px",
    }}
  >
    Title:
  </Typography>
  <Typography
    variant="h6"
    sx={{
      fontWeight: "bold",
      color: "#333",
    }}
  >
    {data.title}
  </Typography>
</Box>
<Box display="flex" alignItems="center" mt={1}>
  <Typography
    variant="h6"
    sx={{
      fontWeight: 600,
      color: "#555",
      marginRight: "8px",
    }}
  >
    Class:
  </Typography>
  <Typography
    variant="h6"
    sx={{
      fontWeight: "bold",
      color: "#333",
    }}
  >
    {data.recipients}
  </Typography>
</Box>

<Box display="flex" alignItems="center" mt={1}>
  <Typography
    variant="h6"
    sx={{
      fontWeight: 600,
      color: "#555",
      marginRight: "8px",
    }}
  >
    Purpose:
  </Typography>
  <Typography
    variant="h6"
    sx={{
      fontWeight: "bold",
      color: "#333",
    }}
  >
    {data.meetingPurpose}
  </Typography>
</Box>



  {/* <Typography
    variant="body2"
    sx={{
      color: "#666",
      fontWeight: "bold",
      marginTop: "5px",
    }}
  >
    {data.meetingPurpose}
  </Typography> */}
                        </Box>

                      </Grid>
                    ))
                  )}
                </Grid>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
      <ToastContainer position="top-right" autoClose={1000} />
    </Card>
  );
}

export default ParentMeetings;



